// Custom code to manipulate the DOM
$(function() {
    let navbarSearhForm = $("#navbar-search-form");
    // Open desktop search
    $("#navbar-search-link").on("click", function (){
        navbarSearhForm.addClass("desktop-search-form");
        // alert("Search?");

    });


    // Close desktop search
    $("#nav-search-close-icon").on("click", function (){
        navbarSearhForm.removeClass("desktop-search-form");
        // alert("Close search?");

    });


    // On scroll rotate and shift stickers
    $(window).scroll(function (){
        scrollRotate();
        scrollShift();
    });

    // Move element for parallax effect
    function scrollShift(){
        let stickerContainer = $(".shifting-sticker");
        if(stickerContainer.length){
            let scrolled = $(window).scrollTop();
            let maxShifting  = 200; /*px to shift while rotating for parallax effect*/
            let refHeight = $(document).height(); /*reference height for shifting*/
            let stickerShift = maxShifting*scrolled/refHeight;

            // image stickers
            stickerContainer.css({
                'transform': 'translate3d(0,-'  + stickerShift + 'px,0)'
            });

            // console.log("Shifting  " + stickerShift + " px");
        }
    }

    // Rotate elements
    function scrollRotate() {
        let stickerContainer = $(".rotating-sticker");
        if(stickerContainer.length){
            let scrolled = $(window).scrollTop();
            let sticker = stickerContainer.find(".sticker");
            let rotationSpeedFactor = 3; /*The lower the number faster it rotates*/

            sticker.css({
                'transform': 'rotate(' + scrolled / rotationSpeedFactor + 'deg)'
            });
            // console.log("Rotating - " + scrolled / rotationSpeedFactor + " deg");
        }


    }


    // On hover change svg pattern images E.g. product, Merch thumbnails
    $('.update-media').mouseenter(function() {
        let postMediaContainer = $(this).find(".post-media");
        let originalMedia = postMediaContainer.find("image").attr("href");
        let hoverMedia = postMediaContainer.data("hover-media");

        if(hoverMedia){

            // Save the original image url
            postMediaContainer.attr("data-original-media", originalMedia);

            // Change image
            postMediaContainer.find("image").attr("href", hoverMedia);
            // console.log("Entered | Changed to hover media - " + hoverMedia);
        }
    }).mouseleave(function() {
        let postMediaContainer = $(this).find(".post-media");
        let originalMedia = postMediaContainer.attr("data-original-media");
        if(originalMedia){
            // Reset the image
            postMediaContainer.find("image").attr("href", originalMedia);
            // console.log("Left | Changed to original media - " + originalMedia);
        }
    });


    // Splide Carousel plugin initialization
    // https://splidejs.com/guides/

    Splide.defaults = {
        type   : 'loop',
        drag   : 'free',
    }

    // Product carousel
    if($("#product-splide").length)
        new Splide( '#product-splide', {
        breakpoints: {
            576: {
                perPage: 1,
            },
            768: {
                perPage: 2,
            },
            992: {
                perPage: 3,
            },
        },
        autoScroll: {
            speed: 1,
        },
    } ).mount( window.splide.Extensions );


    // Testimonial carousel
    if($("#testimonial-splide").length)
        new Splide( '#testimonial-splide', {
        breakpoints: {
            576: {
                perPage: 1,
            },
            640: {
                perPage: 2,
            },
            768: {
                perPage: 3,
            },
            992: {
                perPage: 4,
            },
        },
        autoScroll: {
            speed: -1,
        },
    } ).mount( window.splide.Extensions );


})